import { setApiSession } from '@authvia-v3/pinia-stores-user';

import {
  getAuthenticatedUserIdFromToken,
  getPiniaApiPathPrefixFromToken,
} from '@/utils/authClaims';

/**
 * Align pinia-stores-user path mode (and session userId/token) with the active token.
 * USER → `apiPathPrefix: ''` + userId; legacy/customer → `'/v3'`.
 */
export function syncPiniaApiPathPrefix(
  parseToken: (token: string) => Record<string, unknown>,
  token: string | undefined | null,
): void {
  if (!token) {
    setApiSession({ apiPathPrefix: '/v3' });
    return;
  }

  const apiPathPrefix: '' | '/v3' = getPiniaApiPathPrefixFromToken(parseToken, token);
  const userId: string = getAuthenticatedUserIdFromToken(parseToken, token);

  setApiSession({
    apiPathPrefix,
    token,
    ...(apiPathPrefix === '' && userId ? { userId } : {}),
  });
}
